import { Component } from '@angular/core';
import { CurrentUserService } from '../../core/services/user/current-user.service';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../core/services/user/auth.service';
import { NotificationService } from '../../core/services/notification/notification.service';
import { NotificationList } from '../../core/models/notification/notification-list.model';
import { StatusUtils } from '../../utils/status-utils';
import { SignalRService } from '../../core/services/signalR/signal-r.service';
import { environment } from '../../../environments/environment';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { LanguageService } from '../../core/services/language.service';
declare var KTMenu: any;

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  constructor(
    private router: Router,
    private authService: AuthService,
    private currentUserService: CurrentUserService,
    private notificationService: NotificationService,
    private signalRService: SignalRService,
    private translate: TranslateService,
    private languageService: LanguageService
  ) {}

  currentUser: any = null;
  notificationList: NotificationList[] = [];
  unReadNotificationMessageCount: number = 0;
  statusClass: string = '';
  statusText: string = '';

  ngAfterViewInit(): void {
    if (KTMenu) {
      KTMenu.createInstances();
    }
    this.applyStoredTheme();
  }

  ngOnInit() {
    const userLang = this.languageService.getLanguage() || 'en';
    this.translate.use(userLang);
    this.currentUser = this.currentUserService.GetSession();
    this.statusClass = StatusUtils.getUserStatusClass(this.currentUser?.status);
    this.statusText = StatusUtils.getUserStatusText(this.currentUser?.status);
    this.getNotificationList();
    const signalRBasePath = `${environment.apiLocations.notification}`.split(
      '/api/v1'
    )[0];
    this.signalRService.on(
      'notification-hub',
      'receiveNotificationAdded',
      signalRBasePath,
      (notification) => {
        try {
          const parsedNotification = JSON.parse(notification);
          if (parsedNotification) {
            const notification = {
              id: parsedNotification.Id,
              createdDate: parsedNotification.CreatedDate,
              customerCode: parsedNotification.CustomerCode,
              email: parsedNotification.Email,
              isRead: parsedNotification.IsRead,
              message: parsedNotification.Message,
              userId: parsedNotification.UserId || [],
            };
            this.unReadNotificationMessageCount++;
            this.notificationList = [
              notification,
              ...this.notificationList,
            ].sort((a, b) => {
              return (
                new Date(b.createdDate).getTime() -
                new Date(a.createdDate).getTime()
              );
            });
          }
        } catch (error) {
          console.error('Error: ', error);
        }
      }
    );
  }

  getNotificationList(): void {
    this.notificationService.notificationList().subscribe({
      next: (res) => {
        this.notificationList = res;
        this.getUnReadNotificationMessageCount();
      },
      error: () => {},
    });
  }

  getUnReadNotificationMessageCount(): void {
    this.notificationService.unReadNotificationMessageCount().subscribe({
      next: (res) => {
        this.unReadNotificationMessageCount = res;
      },
      error: () => {},
    });
  }

  checkNotification(id: string): void {
    this.notificationService.readNotification(id).subscribe({
      next: () => {
        this.getNotificationList();
        this.getUnReadNotificationMessageCount();
      },
      error: () => {},
    });
  }

  readAllNotification(): void {
    this.notificationService.readAllNotification().subscribe({
      next: () => {
        this.getNotificationList();
        this.getUnReadNotificationMessageCount();
      },
      error: () => {},
    });
  }

  deleteNotification(id: string): void {
    this.notificationService.deleteNotification(id).subscribe({
      next: () => {
        this.getNotificationList();
        this.getUnReadNotificationMessageCount();
      },
      error: () => {},
    });
  }

  deleteAllNotification(): void {
    this.notificationService.deleteAllNotification().subscribe({
      next: () => {
        this.getNotificationList();
        this.getUnReadNotificationMessageCount();
      },
      error: () => {},
    });
  }

  setTheme(mode: string) {
    localStorage.setItem('data-bs-theme', mode);
    localStorage.setItem('data-bs-theme-mode', mode);
    document.documentElement.setAttribute('data-bs-theme', mode);
  }

  private applyStoredTheme(): void {
    const storedTheme = localStorage.getItem('data-bs-theme');
    if (storedTheme) {
      document.documentElement.setAttribute('data-bs-theme', storedTheme);
    }
  }

  getStatusText(status: number): string {
    return StatusUtils.getUserStatusText(status);
  }

  getStatusClass(status: number): string {
    return StatusUtils.getUserStatusClass(status);
  }

  backToMenu() {
    if (typeof window !== 'undefined') {
      window.location.href = `${environment.apiLocations.menu}`;
    }
  }
}
